import styled from 'styled-components';
import Skeleton from '../../../../components/Skeleton';
import { color, mq, space } from '../../../../stylesheets';

const ListEntrySkeletonDesktop = styled.div`
  height: 53px;
  display: none;
  align-items: center;
  padding: ${space('s')};
  border-bottom: 5px solid ${color('base', 50)};

  ${mq('m')} {
    display: flex;
  }

  & > div {
    width: 18.5%;

    &:nth-of-type(4) {
      width: 22%;
    }

    &:first-of-type {
      flex-grow: 2;
    }
  }
`;

const ListEntrySkeletonMobile = styled.div`
  height: 73px;
  display: flex;
  align-items: center;
  padding: ${space('s')};
  justify-content: space-between;
  background: ${color('neutral', 10)};
  border-bottom: 1px solid ${color('neutral', 70)};
  flex-wrap: wrap;

  ${mq('m')} {
    display: none;
  }

  & > div:last-of-type {
    margin-top: ${space('xxs')};
  }
`;

const ListEntrySkeleton = () => (
  <li>
    <ListEntrySkeletonDesktop>
      <div>
        <Skeleton width="200px" height="16px" />
      </div>
      <div>
        <Skeleton width="100px" height="16px" />
      </div>
      <div>
        <Skeleton width="100px" height="16px" />
      </div>
      <div>
        <Skeleton width="120px" height="16px" />
      </div>
      <div>
        <Skeleton width="80px" height="16px" />
      </div>
    </ListEntrySkeletonDesktop>

    <ListEntrySkeletonMobile>
      <div>
        <Skeleton width="150px" height="20px" />
      </div>
      <div>
        <Skeleton width="150px" height="16px" />
      </div>

      <Skeleton width="50%" height="16px" />
    </ListEntrySkeletonMobile>
  </li>
);

export default ListEntrySkeleton;
